import { create } from 'zustand';
import { api } from '../api/instance.ts';
import { db } from '../storage/db.ts';
import type { PlanCatalog } from './features.ts';

const KEY = 'plans.catalog';

/** The public plan catalog (`GET /v1/plans`), cached for offline paywalls. Loaded on demand. */
export const usePlans = create<{ catalog: PlanCatalog | null; loading: boolean; error: string | null }>(() => ({
  catalog: null,
  loading: false,
  error: null,
}));

let inflight: Promise<PlanCatalog | null> | null = null;

export function loadPlans(force = false): Promise<PlanCatalog | null> {
  const cur = usePlans.getState();
  if (cur.catalog && !force) return Promise.resolve(cur.catalog);
  inflight ??= (async () => {
    usePlans.setState({ loading: true });
    const cached = (await db().kv.get(KEY))?.value as PlanCatalog | undefined;
    if (cached && !usePlans.getState().catalog) usePlans.setState({ catalog: cached });
    try {
      const catalog = await api.plans();
      await db().kv.put({ key: KEY, value: catalog });
      usePlans.setState({ catalog, loading: false, error: null });
      return catalog;
    } catch (e) {
      usePlans.setState({ loading: false, error: e instanceof Error ? e.message : String(e) });
      return usePlans.getState().catalog;
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}
